import {
  UTM_PARAM_KEYS,
  type UtmParamKey,
} from "@tastyworks/shared-browser-utils/utm"
import { browser } from "$app/environment"

// Writes sessionStorage directly (not localStorageStore, which forces
// localStorage under VITE_AUTOMATION_ENV) to keep capture session-scoped, and
// reads window.location instead of a load event's `url` so calling this
// doesn't make an expensive load (e.g. the root layout's auth validation)
// re-run on every nav where a utm_* value changes. Mirrors
// overrideAppPolling() in signup/+page.ts.
export function captureUtmParams() {
  if (!browser) {
    return
  }
  const url = new URL(window.location.href)

  // No utm_* params means an internal nav, not a new landing — leave prior
  // values alone. Otherwise replace the full set, clearing omitted keys, so a
  // new campaign can't merge with a stale value from an earlier one.
  const hasUtmParams = UTM_PARAM_KEYS.some((key) => url.searchParams.get(key))
  if (!hasUtmParams) {
    return
  }

  for (const key of UTM_PARAM_KEYS) {
    const value = url.searchParams.get(key)
    if (value) {
      sessionStorage.setItem(key, value)
    } else {
      sessionStorage.removeItem(key)
    }
  }
}

export function getStoredUtmParams(): Partial<Record<UtmParamKey, string>> {
  const params: Partial<Record<UtmParamKey, string>> = {}
  if (!browser) {
    return params
  }

  for (const key of UTM_PARAM_KEYS) {
    const value = sessionStorage.getItem(key)
    if (value) {
      params[key] = value
    }
  }
  return params
}
